export const getUserCasesInOtherAreasWithFirstOwner = (userId, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject,
    Owner.Name
FROM
    Case
WHERE
    First_Owner__c = '${userId}'
    AND OwnerId NOT IN ('${userId}', '00G41000002Q39NEAS', '00G41000001ohGLEAY')
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
    ${limit ? `LIMIT ${limit}` : ''}
`;
